import { AccountEducation } from '@libs/src/models/account.model';

import compact from 'lodash-es/compact';

export function getReadableEducation(education: AccountEducation) {
  return education
    ? compact([education.program, education.school, education.class_of]).join(
        ', ',
      )
    : '';
}
